import './App.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const START_YEAR = 2025;
const START_MONTH = 3;

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

function getAvailableYears() {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = START_YEAR; y <= currentYear; y++) {
    years.push(y);
  }
  return years;
}

function getAvailableMonths(year) {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const minMonth = year === START_YEAR ? START_MONTH : 1;
  const maxMonth = year === currentYear ? currentMonth : 12;
  const months = [];
  for (let m = minMonth; m <= maxMonth; m++) {
    months.push(m);
  }
  return months;
}

function Nav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [archiveOpen, setArchiveOpen] = useState(false);
  const [hoveredYear, setHoveredYear] = useState(null);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleNewsClick = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.location.reload();
    }
  };

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') {
      return true;
    }
    return location.pathname === path;
  };

  const isArchiveActive = location.pathname.startsWith('/archive');

  useEffect(() => {
    const handleClickOutside = (e) => {
      const clickedButton = buttonRef.current && buttonRef.current.contains(e.target);
      const clickedDropdown = dropdownRef.current && dropdownRef.current.contains(e.target);
      if (!clickedButton && !clickedDropdown) {
        setArchiveOpen(false);
        setHoveredYear(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleArchive = () => {
    if (!archiveOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: 'fixed',
        top: rect.bottom + 10,
        left: rect.left + rect.width / 2,
        transform: 'translateX(-50%)',
      });
    }
    setArchiveOpen(o => !o);
    setHoveredYear(null);
  };

  const handleMonthSelect = (year, month) => {
    navigate(`/archive/${year}/${month}`);
    setArchiveOpen(false);
    setHoveredYear(null);
  };

  const years = getAvailableYears();

  return (
    <div className="Nav-Bar">
      <div className="Nav-Links">
        <Link to="/" onClick={handleNewsClick} className={isActive('/') ? 'active-link' : ''}>NEWS</Link>
        <Link to="/weather" className={isActive('/weather') ? 'active-link' : ''}>WEATHER</Link>
        <Link to="/sports" className={isActive('/sports') ? 'active-link' : ''}>SPORTS</Link>
        <Link to="/lottery" className={isActive('/lottery') ? 'active-link' : ''}>LOTTERY</Link>
        <Link to="/horoscope" className={isActive('/horoscope') ? 'active-link' : ''}>HOROSCOPE</Link>
        <div className="Archive-Nav-Wrapper">
          <button
            ref={buttonRef}
            className={`Archive-Nav-Button${isArchiveActive ? ' active-link' : ''}`}
            onClick={toggleArchive}
          >
            ARCHIVE
          </button>
        </div>
        <Link to="/about" className={isActive('/about') ? 'active-link' : ''}>NEWS TEAM</Link>
        <Link to="/propaganda-machine" className="Red-Button">CONTROL THE NARRATIVE</Link>
      </div>
      {archiveOpen && ReactDOM.createPortal(
        <div ref={dropdownRef} className="Archive-Dropdown" style={dropdownStyle}>
          {years.map(year => (
            <div
              key={year}
              className="Archive-Year-Item"
              onMouseEnter={() => setHoveredYear(year)}
              onMouseLeave={() => setHoveredYear(null)}
            >
              <span className="Archive-Year-Label">{year}</span>
              <span className="Archive-Year-Arrow">›</span>
              {hoveredYear === year && (
                <div className="Archive-Month-Submenu">
                  {getAvailableMonths(year).map(month => (
                    <button
                      key={month}
                      className="Archive-Month-Item"
                      onClick={() => handleMonthSelect(year, month)}
                    >
                      {MONTH_NAMES[month - 1]}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>,
        document.body
      )}
    </div>
  );
}

export default Nav;
